import { useState } from 'react'

import { downloadAttachment } from 'core/use-cases/downloadAttachment'

import { DocumentType } from '../domain/Document'
import { type Attachment } from '../domain/Shipment'
import { DocumentItem } from './DocumentSection/DocumentItem'

export type AttachmentItemProps = Readonly<{
  attachment: Attachment
  quoteUuid: string
  rateUuid: string
}>

export function AttachmentItem({ attachment, quoteUuid, rateUuid }: AttachmentItemProps) {
  const [isDownloading, setIsDownloading] = useState<boolean>(false)

  async function handleClick() {
    setIsDownloading(true)
    try {
      await downloadAttachment({
        attachmentId: attachment.id,
        quoteUuid,
        rateUuid,
      })
    } finally {
      setIsDownloading(false)
    }
  }

  return (
    <DocumentItem
      title={attachment.fileName}
      aria-label={`View ${attachment.fileName}`}
      loading={isDownloading}
      onClick={handleClick}
      type={DocumentType.Other}
    />
  )
}
